import React, { forwardRef } from 'react';

import { ButtonProps } from './types';
import { Loader } from '../Loader';

import {
  DefaultButton,
  DefaultDestructiveButton,
  PrimaryButton,
  PrimaryDestructiveButton,
  FlatButton,
  LinkButton,
  UnstyledButton,
  LoadingWrapper,
  MainContent,
} from './components/styled';
import { DropdownIcon } from '../../icons/DropdownIcon';

const variantMap = {
  default: DefaultButton,
  primary: PrimaryButton,
  destructive: DefaultDestructiveButton,
  primaryDestructive: PrimaryDestructiveButton,
  flat: FlatButton,
  link: LinkButton,
  unstyled: UnstyledButton,
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      children,
      iconSlot,
      variant = 'default',
      size = 'base',
      dropdown = false,
      loading = false,
      contentStyles,
      ...otherProps
    }: ButtonProps,
    ref,
  ) => {
    if (variant === 'unstyled') {
      return (
        <UnstyledButton ref={ref} className={className} {...otherProps}>
          {children}
        </UnstyledButton>
      );
    }

    const VariantButton = variantMap[variant];

    const hasChildren = children !== undefined;
    const hasIcon = !!iconSlot;
    return (
      <VariantButton
        ref={ref}
        className={className}
        size={size}
        hasText={hasChildren}
        hasIcon={hasIcon}
        hasDropdown={dropdown}
        {...otherProps}
      >
        {(hasChildren || hasIcon) && (
          <MainContent
            $loading={loading}
            hasText={!!children}
            size={children || size === 'sm' ? 'base' : 'md'}
            style={contentStyles}
          >
            {iconSlot && iconSlot}
            {children !== undefined && children}
            {dropdown && <DropdownIcon />}
          </MainContent>
        )}

        {loading && (
          <LoadingWrapper>
            <Loader />
          </LoadingWrapper>
        )}
      </VariantButton>
    );
  },
);
